import React, { useState } from 'react';

const TutorialModal = ({ onClose }) => {
  const [step, setStep] = useState(1);

  const handleNext = () => {
    if (step < 3) setStep(step + 1);
    else onClose(); // 3단계에서 버튼 누르면 종료
  };

  const renderContent = () => {
    switch (step) {
      case 1:
        return {
          title: "⚔️ 진영을 선택하십시오",
          desc: "The Pivot은 두 개의 거대 진영으로 나뉘어 있습니다. 당신의 신념과 논리에 맞는 진영을 선택하여 전투에 합류하십시오. 생각이 달라지면 진영은 언제든 변경 가능합니다.",
          icon: <div style={{fontSize: '3rem', marginBottom: '20px'}}>🔵 vs 🔴</div>
        };
      case 2:
        return {
          title: "🪙 논리를 증명하고 보상받으세요",
          desc: "단순한 비난이 아닌, 논리적인 근거로 상대를 설득하십시오. 승리한 진영과 기여도가 높은 논객에게는 '포인트'가 지급됩니다.",
          icon: <div style={{fontSize: '3rem', marginBottom: '20px'}}>📜💎</div>
        };
      case 3:
        return {
          title: "⚠️ AI 분석 시스템 (Warning)",
          desc: "건전한 게시판 분위기를 위해 AI가 게시한 내용의 오염도를 분석합니다. 비속어, 혐오 표현 등으로 판단될 경우 타 이용자에 의해 신고될 수 있으며, 누적 시 제재가 가해질 수 있습니다.",
          icon: <div style={{fontSize: '3rem', marginBottom: '20px'}}>🤖🚫</div>
        };
      default:
        return {};
    }
  };

  const content = renderContent();

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* 진행 상태 바 (Steps) */}
        <div style={styles.stepIndicator}>
          <div style={{...styles.dot, background: step >= 1 ? '#00d4ff' : '#333'}}></div>
          <div style={{...styles.line, background: step >= 2 ? '#00d4ff' : '#333'}}></div>
          <div style={{...styles.dot, background: step >= 2 ? '#00d4ff' : '#333'}}></div>
          <div style={{...styles.line, background: step >= 3 ? '#00d4ff' : '#333'}}></div>
          <div style={{...styles.dot, background: step >= 3 ? '#00d4ff' : '#333'}}></div>
        </div>

        <div style={styles.content}>
          {content.icon}
          <h2 style={styles.title}>{content.title}</h2>
          <p style={styles.desc}>{content.desc}</p>
        </div>

        <button onClick={handleNext} style={styles.button}>
          {step === 3 ? "전장으로 입장하기" : "다음 (Next) >"}
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    zIndex: 1000,
    backdropFilter: 'blur(5px)' // 배경 블러 처리
  },
  modal: {
    width: '90%', maxWidth: '400px',
    backgroundColor: '#161616',
    border: '1px solid #333',
    borderRadius: '12px',
    padding: '30px',
    textAlign: 'center',
    boxShadow: '0 0 20px rgba(0, 212, 255, 0.2)',
    animation: 'fadeIn 0.3s ease-out'
  },
  stepIndicator: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: '30px'
  },
  dot: { width: '12px', height: '12px', borderRadius: '50%', transition: '0.3s' },
  line: { width: '30px', height: '2px', transition: '0.3s' },
  content: { minHeight: '180px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  title: { fontSize: '1.4rem', color: '#fff', marginBottom: '15px' },
  desc: { color: '#aaa', lineHeight: '1.6', fontSize: '0.95rem' },
  button: {
    marginTop: '20px',
    width: '100%',
    padding: '12px',
    backgroundColor: '#00d4ff',
    color: '#000',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: '0.2s'
  }
};

export default TutorialModal;